import { render, staticRenderFns } from "./RuleItems.vue?vue&type=template&id=76427347"
import script from "./RuleItems.vue?vue&type=script&lang=ts"
export * from "./RuleItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports